import React, { useState, useEffect  } from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'

import Layout from '../components/Layout'
import Optimize from '../components/Optimize'

import Header from '../components/Header'
import StickyBar from '../components/platinum_relaunch/StickyBar'
import List from '../components/platinum_relaunch/List'
import Break from '../components/platinum_relaunch/Break'
import Container from '../components/platinum_relaunch/Container'
import IntroImage from '../components/platinum_relaunch/IntroImage'
import imageLarge from '../images/platinum_relaunch/kv-platinum-boost-1920@2x.jpg'
import imageSmall from '../images/platinum_relaunch/kv-platinum-boost-375@2x.jpg'
import cardImageZoom from '../images/platinum_relaunch/card_platinum.png'
import cardImageZoomMobile from '../images/platinum_relaunch/card_platinum_768.png'
import Xsell from '../components/platinum_relaunch/Xsell'
import Steps from '../components/platinum_relaunch/Steps'
import Content from '../components/platinum_relaunch/Content'
import ContentModul from '../components/platinum_relaunch/ContentModul'
import Banner from '../components/platinum_relaunch/Banner'
import TechnicSlides from '../components/platinum_relaunch/TechnicSlides'
import CardBox from '../components/platinum_relaunch/CardBox'
import Footer from '../components/platinum_relaunch/Footer'
import ContentCols from '../components/platinum_relaunch/ContentCols'
import ContentModulCol from '../components/platinum_relaunch/ContentModulCol'
import ContentSlides from '../components/platinum_relaunch/ContentSlides'
import Value from '../components/platinum_relaunch/Value'
import logoAmexExperiences from '../images/platinum_relaunch/logo_amex_experiences.svg'
import logoAmexFineHotels from '../images/platinum_relaunch/logo_amex_fine_hotels.svg'
import logoAmexOffers from '../images/platinum_relaunch/logo_amex_offers.svg'
import logoAvis from '../images/platinum_relaunch/logo_avis.svg'
import logoGlobalLoungeCollection from '../images/platinum_relaunch/logo_global_lounge_collection.png'
import logoGlobalDiningCollection from '../images/platinum_relaunch/logo_global_dining_collection.svg'
import logoHertz from '../images/platinum_relaunch/logo_hertz.svg'
import logoHotelCollection from '../images/platinum_relaunch/logo_hotel_collection.svg'
import logoMembershipRewards from '../images/platinum_relaunch/logo_membership_rewards.svg'
import logoPriorityPass from '../images/platinum_relaunch/logo_priority_pass.svg'
import logoSixt from '../images/platinum_relaunch/logo_sixt.svg'
import logoApplePay from '../images/platinum_relaunch/logo-apple-pay.svg'
import logoAmexApp from '../images/platinum_relaunch/logo-amex-app.svg'
import logoContactless from '../images/platinum_relaunch/logo-contactless.svg'
import logoBestSales from '../images/platinum_relaunch/logo-best-sales.svg'
import badgeChip from '../images/platinum_relaunch/badge_chip.svg'
import badgeMoney from '../images/platinum_relaunch/badge_money.svg'
import badgeHandelsblatt from '../images/platinum_relaunch/badge_handelsblatt.svg'
import badgeTravel from '../images/platinum_relaunch/badge_travel.svg'

const theme = {
  name: 'platinum-relaunch',
}

const variant = 'angebot-platinum'

const PlatinumPage = ({ data }) => {

  const [isSmall, setIsSmall] = useState(false)
  const [isMedium, setIsMedium] = useState(false)
  const [isLarge, setIsLarge] = useState(false)
  useEffect(() => {
    window.onresize = function() {
      if (window.outerWidth < 767) {
        setIsSmall(true);
        setIsMedium(false);
        setIsLarge(false);
      }
      else if(window.outerWidth >= 768 && window.outerWidth < 1023 ){
        setIsSmall(false);
        setIsMedium(true);
        setIsLarge(false)
      }
      else if(window.outerWidth >= 1024 && window.outerWidth < 1240){
        setIsSmall(false);
        setIsMedium(false);
        setIsLarge(true);
      }
      else {
        setIsSmall(false);
        setIsMedium(false);
        setIsLarge(false);
      }
    }
    window.onresize();
  },[])

  return (
    <Layout theme={theme} styleGray={true}>
      <Helmet>
        <style type="text/css">{`${appendCssToHead}`}</style>
        <script type="application/javascript">{`${appendJsToHead}`}</script>
        <noscript>
          {`<!-- Pinterest--><img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?event=init&tid=2612918883631&pd[em]=<hashed_email_address>&noscript=1" />`}
        </noscript>
      </Helmet>

      <Header currentCard="platinum" currentVariant={variant} />

      <IntroImage
        card={<Img fluid={data.cardImagePlatinum.childImageSharp.fluid} />}
        cardZoom={<img src={cardImageZoom} />}
        cardZoomMobile={<img src={cardImageZoomMobile} />}
        scrollToId="vorteile"
        title="Platinum"
        subtitle={
          <>
            <strong style={{fontWeight: 700}}>Immer an Ihrer Seite.</strong>
          </>
        }
        imageLarge={imageLarge}
        imageSmall={imageSmall}
      />

      <Xsell
        cardConsumer={
          <Img fluid={data.cardImagePlatinum.childImageSharp.fluid} />
        }
        cardBusiness={
          <Img fluid={data.cardImagePlatinumBusiness.childImageSharp.fluid} />
        }
        teaserTitleConsumer={
          <>
            Privat auf American
            <Break /> Express setzen?
          </>
        }
        teaserTitleBusiness={
          <>
            Sie sind <Break desktop />
            selbstständig?
          </>
        }
        teaserContentConsumer="Die Platinum Card aus Metall."
        teaserContentBusiness="Die Business Platinum Card aus Metall."
        titleConsumer={
          <>
            Jetzt upgraden: <Break />
            Die Platinum Card aus Metall.
          </>
        }
        titleConsumerMobile={
          <>
            Jetzt upgraden: <Break />
            Die Platinum Card.
          </>
        }
        titleBusiness="Jetzt die Business Platinum Card sichern."
        contentConsumer={
          <List>
            <List.Item>
              100 Euro Startguthaben<sup>2)</sup>
            </List.Item>
            <List.Item>
              200 Euro jährliches Online-Reiseguthaben<sup>3)</sup>
            </List.Item>
            <List.Item>
              200 Euro jährliches SIXT ride Fahrtguthaben<sup>6)</sup>
            </List.Item>
          </List>
        }
        contentConsumerMobile={
          <List blank>
            <List.Item>
              <span className="bold">+</span> 100 Euro Startguthaben<sup>2)</sup>
            </List.Item>
            <List.Item>
              <span className="bold">+</span> 200 Euro jährliches Online-Reiseguthaben<sup>3)</sup>
            </List.Item>
            <List.Item>
              <span className="bold">+</span> 200 Euro jährliches SIXT ride Fahrtguthaben<sup>6)</sup>
            </List.Item>
          </List>
        }
        contentBusiness={
          <List>
            <List.Item>200 Euro Startguthaben</List.Item>
            <List.Item>Bis zu 58 Tage Zahlungsziel</List.Item>
            <List.Item>Umfassendes Versicherungspaket</List.Item>
          </List>
        }
        contentBusinessMobile={
          <List blank>
            <List.Item>
              <span className="bold">+</span> 200 Euro Startguthaben
            </List.Item>
            <List.Item>
              <span className="bold">+</span> Bis zu 58 Tage Zahlungsziel
            </List.Item>
            <List.Item>
              <span className="bold">+</span> Umfassendes Versicherungspaket
            </List.Item>
          </List>
        }
        businessUrl="https://www.amex-business.de/platinum-startguthaben/?sourcesuffix=AM03195787&cpid=0820CSPLCB03"
      />

      <StickyBar
        variant={variant}
        linkedin
        card={data.cardImagePlatinum.childImageSharp.sticky}
        title={
          <>
            Die Platinum Card <Break />
            aus Metall.
          </>
        }
        mobileSubline={
          <>
            100 Euro Startguthaben<sup>2)</sup>
          </>
        }
        spaceEvenly
        content={
          <List small inline bold>
            <List.Item>
              100 Euro Startguthaben<sup>2)</sup>
            </List.Item>
            <List.Item blank>Nur 55 Euro im Monat</List.Item>
          </List>
        }
      />

      <Steps
        title={
          <>
            Die Platinum Card mit Video Ident in <Break desktop />
            wenigen Minuten beantragen.
          </>
        }
        items={[
          {
            content: <>Platinum Card ganz bequem online beantragen</>,
          },
          {
            content: (
              <>
                Schnell und kostenfrei legitimieren über Video Ident oder Post
                Ident
              </>
            ),
          },
          {
            content: <>Karte erhalten, freischalten und direkt einsetzen</>,
          },
        ]}
        variant={variant}
        linkedin
      />

      <Value
        isSmall={isSmall}
        isMedium={isMedium}
        title={<>Mehrwert ohnegleichen.</>}
        subtitle={<>Großes Vorteilspaket – kleiner Monatsbeitrag.</>}
        card={<Img className="card" fluid={data.cardImagePlatinum.childImageSharp.fluid} />}
        month={<>55</>}
        year={<>660</>}
        items={[
          {
            id: "package",
            amount: <>4.882</>,
            shortTitle: <>Vorteilspaket</>,
            title: <>Mehrwert ohnegleichen</>,
            content:
              <>
                <p>
                Die neue Platinum Card aus Metall ist in jeder Situation der passende Begleiter. Denn die Karte bietet Vorteile im Wert von bis zu <strong>4.782 Euro</strong>. Und das jedes Jahr. Plus einmalig <strong>100 Euro Startguthaben</strong><sup>1)</sup>.
                </p>
              </>
          },
          {
            id: "bonus",
            amount: <>150</>,
            shortTitle: <>Bonusprogramm</>,
            title: <>Membership Rewards<sup>&reg;</sup> Bonusprogramm</>,
            content:
              <>
                <p>
                  Mit jeder Zahlung Punkte sammeln und flexibel einlösen. 1 Euro Kartenumsatz = 1 Membership Rewards Punkt.
                </p>
              </>
          },
          {
            id: "travel",
            amount: <>1.518</>,
            shortTitle: <>Hotel-und Reisevorteile</>,
            title: <>Zahlreiche Hotel- und Reisevorteile</>,
            content:
              <>
                <List dots small>
                  <List.Item>Fine Hotels & Resorts (1.000 Hotels weltweit erwarten Sie mit ganz besonderen Extras, wie zum Beispiel garantiertem Late Check-out bis 16 Uhr)</List.Item>
                  <List.Item>The Hotel Collection (Guthaben und Upgrade bei Verfügbarkeit)</List.Item>
                  <List.Item>Hotel- und Mietwagenpartnerprogramme (bevorzugter Status, ohne die üblichen Voraussetzungen erfüllen zu müssen)</List.Item>
                  <List.Item>Jährliches 200 Euro SIXT ride Fahrtguthaben<sup>3)</sup></List.Item>
                  <List.Item>Jährliches 200 Euro Online-Reiseguthaben<sup>2)</sup></List.Item>
                </List>
              </>
          },
          {
            id: "credit",
            amount: <>100</>,
            shortTitle: <>Einmaliges Startguthaben</>,
            title: <>Einmalig 100 Euro Startguthaben</>,
            content:
              <>
                <p>
                  Nach einem Umsatz von mindestens 6.000 Euro innerhalb der ersten 6 Monate.<sup>1)</sup>
                </p>
              </>
          },
          {
            id: "insurance",
            amount: <>1.080</>,
            shortTitle: <>Umfassendes Versicherungspaket<sup>4)</sup></>,
            title: <>Umfassendes Versicherungspaket<sup>4)</sup></>,
            content:
              <>
                <List dots small>
                  <List.Item>Auslandsreise-Krankenversicherung</List.Item>
                  <List.Item>Reise-Unfallversicherung</List.Item>
                  <List.Item>Reiserücktrittsversicherung</List.Item>
                  <List.Item>Reiseabbruch- und Reiseunterbrechungs-Versicherung</List.Item>
                  <List.Item>Reisegepäckversicherung</List.Item>
                  <List.Item>Reisekomfort-Versicherung</List.Item>
                  <List.Item>Mietwagen-Vollkasko- und Haftpflicht-Versicherung</List.Item>
                  <List.Item>Privathaftpflicht- und Prozesskosten-Versicherung</List.Item>
                </List>
              </>
          },
          {
            id: "airport",
            amount: <>798</>,
            shortTitle: <>Airport Lounge-Zugang</>,
            title: <>Airport Lounge-Zugang</>,
            content:
              <>
                <p>
                  Priority Pass<sup>&trade;</sup> für Hauptkarteninhaber und Platinum Card Zusatzkarteninhaber mit Zugang zu mehr als 1.200 Lounges an über 500 Flughäfen in mehr als 130 Ländern weltweit – inklusive je einer Begleitperson.
                </p>
              </>
          },
          {
            id: "cards",
            amount: <>1.236</>,
            shortTitle: <>Zusatzkarten</>,
            title: <>Kartenportfolio</>,
            content:
              <>
                <p>
                  Neben der Hauptkarte sind noch weitere Karten kostenfrei in Ihrer Mitgliedschaft enthalten<sup>5)</sup>:
                </p>
                <List dots small>
                  <List.Item>1 Platinum Card Zusatzkarte aus Metall</List.Item>
                  <List.Item>4 weitere Zusatzkarten als Gold Card oder American Express Card</List.Item>
                  <List.Item>1 Platinum Plus Card, um z.B. ein abweichendes Bankkonto zu hinterlegen</List.Item>
                </List>
              </>
          }
        ]}
      />

      <Content
        id="vorteile"
        title="Alle Vorteile entdecken"
        bannerPosition={3}
        modules={[
          <ContentModul
            reverse
            badge={badgeTravel}
            image={
              <Img fluid={data.contentImage_09_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_09_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Reise-Upgrade</>}
            teaserTitle={
              <>
                Zeit, sich wieder <Break />
                verwöhnen zu lassen.
              </>
            }
            teaserText={
              <>
                Urlaub, der mehr von Deutschland, Europa und der Welt sieht: mit <strong>jährlich 200 Euro Reiseguthaben<sup>3)</sup></strong> für Online-Buchungen über American Express Reisen, Statusvorteilen bei Hotelpartnern und Extras wie <strong>Zimmer-Upgrades, Late Check-out, kostenfreies Frühstück u.v.m.</strong>
                <br /><br />
                <strong>Zeit für neue Reiseideen:</strong> Entdecken Sie attraktive Angebote und sichern Sie sich über Amex Offers eine Gutschrift für Ihren nächsten Urlaub.
              </>
            }
            logos={[logoAmexFineHotels, logoHotelCollection]}
            overviewTitle={<>Überblick</>}
            overviewText={
              <List blank lines>
                <List.Item>
                  200 Euro jährliches Guthaben für American Express Reisen
                  <List.Sub>
                    Weltweite Buchung von Hotels, Mietwagen, Flügen
                  </List.Sub>
                </List.Item>
                <List.Item>
                  Fine Hotels & Resorts: Zimmer-Upgrades, Early Check-in, Late
                  Check-out, kostenfreies Frühstück für 2 Pers. in über 1.000
                  Häusern
                  <List.Sub>Buchbar nach Verfügbarkeit</List.Sub>
                </List.Item>
                <List.Item>
                  The Hotel Collection: 100 US-Dollar Hotelguthaben +
                  Zimmer-Upgrade in mehr als 600 Hotels weltweit
                  <List.Sub>
                    Buchbar nach Verfügbarkeit bei einem Aufenthalt von zwei oder
                    mehr Nächten
                  </List.Sub>
                </List.Item>
                <List.Item>
                  Status-Upgrades bei Hotelpartnern
                  <List.Sub>
                    Radisson Rewards<sup>&trade;</sup> Gold, Hilton Honors Gold
                    Status, MeliáRewards Gold, Shangri-La Golden Circle Jade
                    Mitgliedschaft, Marriott Bonvoy<sup>&trade;</sup> Gold Elite
                    Status
                  </List.Sub>
                </List.Item>
                <List.Item>
                  Ermäßigungen und Bordguthaben bei Kreuzfahrtpartnern
                </List.Item>
                <List.Item>Attraktive Tarife bei Airlinepartnern</List.Item>
              </List>
            }
          />,
          <ContentModul
            image={
              <Img fluid={data.contentImage_02_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_02_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Unbegrenzte Mobilität</>}
            teaserTitle={
              <>
                Überall <Break />
                ankommen.
              </>
            }
            teaserText={
              <>
                Mobilität, die schneller ans Ziel bringt: Mit <strong>jährlich 200 Euro Guthaben</strong> für SIXT ride <sup>6)</sup> – einsetzbar für zehn Fahrten mit jeweils bis zu 20 Euro Ersparnis – sowie zusätzlichen Status-und Fahrzeugkategorie-<strong>Upgrades oder Ermäßigungen</strong> bei Mietwagenpartnern. Valet Park-Service und Car Rental Valet-Service verschaffen Ihnen am Flughafen einen wertvollen Vorsprung.
              </>
            }
            logos={[logoSixt, logoAvis, logoHertz]}
            overviewTitle={<>Überblick</>}
            overviewText={
              <List blank lines>
                <List.Item>
                  200 Euro jährliches SIXT ride Fahrtguthaben<sup>6)</sup>.<Break />
                  Über 1 Million Fahrer stehen weltweit für Sie bereit.
                  <List.Sub>
                    Einsetzbar für bis zu zehn Buchungen mit jeweils maximal 20 Euro Guthaben pro Fahrt.<Break />
                    Gültig für Taxi- und Limousinenservice und Flughafentransfer
                  </List.Sub>
                </List.Item>
                <List.Item>
                  Status-Upgrades und somit Fahrzeugkategorie-Upgrades sowie Ermäßigungen bei Mietwagenpartnern.
                  <List.Sub>
                    Sixt Platinum Card, Avis Preferred, Hertz Gold Plus Rewards
                  </List.Sub>
                </List.Item>
                <List.Item>
                  Valet Park-Service und Car Rental Valet-Service
                  <List.Sub>
                    Berlin-Tegel, Düsseldorf, Frankfurt/Main, Hamburg, Hannover, Köln-Bonn, München, Stuttgart
                  </List.Sub>
                </List.Item>
              </List>
            }
          />,
          <ContentModul
            reverse
            image={
              <Img fluid={data.contentImage_04_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_04_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Versicherungen</>}
            teaserTitle={
              <>
                Sicher<Break />
                verreisen.
              </>
            }
            teaserText={
              <>
                Rundumschutz, der wirklich an alles denkt: mit einem umfassenden Reiseschutzpaket<sup>4)</sup> für alle, die jetzt wieder unterwegs sind.<Break />
                Und für alle Eventualitäten – von der Planung einer Reise bis zur Rückkehr in die Heimat.
              </>
            }
            overviewTitle={<>Überblick</>}
            overviewText={
              <List blank lines>
                <List.Item>Auslandsreise-Krankenversicherung</List.Item>
                <List.Item>Reiserücktrittskosten-Versicherung</List.Item>
                <List.Item>
                  Reiseabbruch- und Reiseunterbrechungs-Versicherung
                </List.Item>
                <List.Item>Reisegepäck-Versicherung</List.Item>
                <List.Item>Reise-Unfallversicherung</List.Item>
                <List.Item>
                  Reisekomfort-Versicherung bei Flug-/Gepäckverspätungen,
                  Gepäckverlust und verpassten Anschlussflügen
                </List.Item>
                <List.Item>Reise-Privathaftpflicht-Versicherung</List.Item>
                <List.Item>
                  Mietwagen-Diebstahl-, Kasko- und Haftpflichtversicherung
                </List.Item>
                <List.Item>Kfz-Schutzbrief</List.Item>
              </List>
            }
          />,
          <ContentModul
            image={
              <Img fluid={data.contentImage_10_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_10_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Lifestyle & Events</>}
            teaserTitle={
              <>
                Mehr erleben – <Break />
                virtuell und vor Ort.
              </>
            }
            teaserText={
              <>
                Erlebnisse, die länger in Erinnerung bleiben: mit <strong>Zugang zu einzigartigen und maßgeschneiderten Events</strong> aus Sport, Fashion, Entertainment, Musik, Gourmet und Kunst, zu denen Platinum Card Inhaber eingeladen sind.
              </>
            }
            logos={[logoGlobalDiningCollection, logoAmexExperiences, logoBestSales]}
            logoBestSales
            overviewTitle={<>Überblick</>}
            overviewText={
              <List blank lines>
                <List.Item>
                  Exklusiver Zugang zu Events aus Sport, Fashion, Entertainment, Musik, Gourmet und Kunst
                </List.Item>
                <List.Item>
                  Reservierte Tickets, Pre-Sales und Meet & Greets
                  <List.Sub>
                    für Events aus Sport, Fashion, Entertainment, Musik, Kulinarik und Kunst
                  </List.Sub>
                </List.Item>
                <List.Item>
                  Global Dining Collection: exklusive Reservierungen und weitere Vorteile in Restaurants weltbekannter Küchenchefs
                </List.Item>
                <List.Item>
                  Direkter Zugang zu Shopping-Communitys und Plätzen bei Fashion-Shows
                </List.Item>
                <List.Item>
                  Zugang zu Mitgliedschaften
                  <List.Sub>
                    Golf Fee Card International, Sansibar The Fine Wine Club u.v.m.
                  </List.Sub>
                </List.Item>
                <List.Item>
                  4 x jährlich Departures Magazin
                  <List.Sub>
                    Exklusives Reise- und Lifestyle-Magazin für Platinum Mitglieder
                  </List.Sub>
                </List.Item>
              </List>
            }
          />

        ]}
        banner={
          <Banner
            items={[
              {
                amount: <>100 Euro</>,
                special: (
                  <>
                    Startguthaben mit der Platinum Card<sup>2)</sup>
                  </>
                ),
              },
              {
                amount: <>200 Euro</>,
                special: (
                  <>
                    Jährliches Online-Reiseguthaben<sup>3)</sup>
                  </>
                ),
              },
              {
                amount: <>200 Euro</>,
                special: (
                  <>
                    Jährliches SIXT&nbsp;ride Fahrtguthaben<sup>6)</sup>
                  </>
                ),
              },
            ]}
          />
        }
      />

      <ContentSlides
        title={<>Schöpfen Sie das volle <Break />Potenzial Ihrer Karte aus.</>}
        subtitle={"Heute und in Zukunft"}
        modules={[
          <ContentModul
            image={
              <Img fluid={data.contentImage_01a_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_01a_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Kontaktlos</>}
            teaserTitle={
              <>
                Abstand halten <Break />
                leicht gemacht.
              </>
            }
            teaserText={
              <>
                Flexibilität, die <strong>gesunde Distanz ermöglicht:</strong> mit der Kontaktlosfunktion, um die Karte nicht mehr aus der Hand geben zu müssen und zudem <strong>schneller an der Kasse vorbeizukommen</strong>. An vielen Automaten, in zahlreichen Geschäften auch bei Beträgen über 50 Euro.
              </>
            }
          />,
          <ContentModul
            image={
              <Img fluid={data.contentImage_07_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_07_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Zusatzkarten</>}
            teaserTitle={
              <>
                Glück geteilt
                <Break />
                durch 7.
              </>
            }
            teaserText={
              <>
                Vorteile, die man weitergeben kann: mit bis zu <strong>sieben Karten
                <sup>5)</sup></strong> und der Möglichkeit, Membership Rewards Punkte auf
                einem gemeinsamen Konto zu sammeln.
              </>
            }
            overviewTitle={<>Überblick</>}
            overviewText={
              <List blank lines>
                <List.Item>1 Platinum Card Hauptkarte aus Metall</List.Item>
                <List.Item>1 Platinum Card Zusatzkarte aus Metall</List.Item>
                <List.Item>
                  4 weitere Zusatzkarten
                  <List.Sub>als Gold Card oder American Express Card</List.Sub>
                </List.Item>
                <List.Item>
                  1 Platinum Plus Card
                  <List.Sub>für ein abweichendes Bankkonto</List.Sub>
                </List.Item>
              </List>
            }
          />,
          <ContentModul
            image={
              <Img fluid={data.contentImage_05_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_05_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Bonusprogramm & Angebote</>}
            teaserTitle={
              <>
                Punkten und <Break />
                profitieren.
              </>
            }
            teaserText={
              <>
                Prämien, die jeden Karteneinsatz belohnen: Mit Membership Rewards®, dem Bonusprogramm von American Express<sup>&reg;</sup>, <strong>bei jeder Zahlung Punkte sammeln</strong> und nach Belieben einlösen. Außerdem bietet Amex Offers <strong>ExtraPunkte, Gutschriften und Nachlässe</strong> bei zahlreichen Akzeptanzpartnern.
              </>
            }
            logos={[logoMembershipRewards, logoAmexOffers]}
            overviewTitle={<>Überblick</>}
            overviewText={
              <List blank lines>
                <List.Item>
                  1 Euro Kartenumsatz = 1 Membership Rewards Punkt
                </List.Item>
                <List.Item>
                  Kartentransaktionen nachträglich mit Punkten begleichen
                </List.Item>
                <List.Item>
                  Vielfältige weitere Einlösemöglichkeiten: <Break />
                  Sachprämien, Reisen, Gutscheine, Prämienflüge, Spenden
                </List.Item>
                <List.Item>
                  Amex Offers:
                  <Break />
                  Wechselnde Angebote für Shopping, Dining, Reisen und mehr
                  <List.Sub>
                    Aktuelle Angebote in der App auswählen, aktivieren und
                    automatisch sparen
                  </List.Sub>
                </List.Item>
              </List>
            }
          />,
          <ContentModul
            image={
              <Img fluid={data.contentImage_01_Platinum.childImageSharp.fluid} />
            }
            imageMobile={
              <Img
                fluid={data.contentImage_01_Platinum_mobile.childImageSharp.fluid}
              />
            }
            teaserCategory={<>Zugang zu Airport Lounges & Services</>}
            teaserTitle={
              <>
                Abseits der <Break />
                Hektik.
              </>
            }
            teaserText={
              <>
                Entspannung, die Reisen komfortabler macht: mit kostenfreiem{' '}
                <strong>Zugang für Haupt- und Zusatzkarteninhaber</strong>{' '}
                inklusive je einer Begleitperson in weltweit mehr als 1.200
                Airport Lounges sowie <strong>Valet Park-Service</strong> an acht
                großen deutschen Flughäfen.
              </>
            }
            logos={[logoPriorityPass, logoGlobalLoungeCollection]}
            overviewTitle={<>Überblick</>}
            overviewText={
              <List blank lines>
                <List.Item>
                  2 x Priority Pass<sup>&trade;</sup> Mitgliedschaft kostenfrei
                  <List.Sub>
                    für Haupt- und Zusatzkarteninhaber plus je 1 Begleitperson
                  </List.Sub>
                </List.Item>
                <List.Item>
                  1.200+ Lounges der American Express Global Lounge Collection an über 500 Flughäfen in 130 Ländern weltweit inklusive
                  <List.Sub>
                    The Centurion Lounge, International American Express Lounges, Delta SkyClub<sup>&reg;</sup>, Escape Lounges (USA), Airspace, Plaza Premium Lounge, Lufthansa Lounges
                  </List.Sub>
                </List.Item>
              </List>
            }
          />
        ]}
      />


      <TechnicSlides
        hidePrevArrow
        items={[
          {
            logo: logoApplePay,
            title: <>Apple Pay</>,
            subline: <>Modern, mobil, mühelos.</>,
            text: (
              <>
                Shoppen, wie es zeitgemäß ist: mit modernen Funktionen wie Apple
                Pay und Ihrem iPhone oder Ihrer Apple Watch in vielen
                Geschäften <strong>einfach und schnell mobil bezahlen.</strong>
              </>
            ),
          },
          {
            logo: logoAmexApp,
            title: <>Amex App</>,
            subline: <>Alles unter Kontrolle.</>,
            text: (
              <>
                Ein Begleiter, der alles im Blick hat: mit der Amex App für die{' '}
                <strong>einfache Übersicht</strong> über Kontobewegungen,
                Membership Rewards Punkte, verfügbare Airport Lounges u.v.m.
                Jederzeit, überall und noch bequemer dank{' '}
                <strong>Push-Benachrichtigungen</strong> zu Ihren Transaktionen.
              </>
            ),
          },
        ]}
      />
      <Container small>
        <ContentModul
          reverse
          membership
          image={
            <>
              <img src={badgeChip} alt="Chip" />
              <img src={badgeHandelsblatt} alt="Handelsblatt" />
              <img src={badgeMoney} alt="Focus Money" />
            </>
          }
          teaserCategory={<>Mitglied werden</>}
          teaserTitle={
            <>
              Willkommen <Break />
              im Club.
            </>
          }
          teaserList={
            <List blank linesBottom>
              <List.Item>Persönlicher telefonischer Service 24/7</List.Item>
              <List.Item>Kostenlose SMS- und E-Mail-Benachrichtigungen</List.Item>
              <List.Item>
                Sicher shoppen mit American Express SafeKey<sup>&reg;</sup> &
                persönlicher PIN
              </List.Item>
              <List.Item>
                Erweitertes 90-tägiges Rückgaberecht<sup>4)</sup> für Ihre
                Einkäufe
              </List.Item>
              <List.Item>
                ShopGarant: 90 Tage Schutz für Ihre Einkäufe<sup>4)</sup>
                <List.Sub>gegen Einbruch-Diebstahl und Beschädigung</List.Sub>
              </List.Item>
              <List.Item>
                Umfassender Schutz bei unverschuldetem Kartenmissbrauch
              </List.Item>
              <List.Item>
                Kostenfreie Ersatzkarte bei Verlust oder Diebstahl
              </List.Item>
              <List.Item>
                Finanzielle Flexibilität (kein vorgegebenes Ausgabenlimit)
              </List.Item>
            </List>
          }
        />
      </Container>

      <CardBox
        packaging={<Img fluid={data.boxPackaging.childImageSharp.fluid} />}
        inlay={<Img fluid={data.boxInlay.childImageSharp.fluid} />}
        variant={variant}
        linkedin
      />

      <Footer>
        <p>
          1) Das Mobilitätsguthaben setzt sich zusammen aus: 200 Euro jährliches SIXT ride Fahrtguthaben und 200 Euro jährliches Online-Reiseguthaben<sup>3)</sup>.
        </p>

        <p>
          2) Nach Kartenerhalt und einem Umsatz von mindestens 6.000 Euro (nach Abzug von etwaigen Gutschriften von Vertragspartnern) innerhalb der ersten 6 Monate mit der Karte erhalten Sie ein Startguthaben in Höhe von 100 Euro auf Ihr Kartenkonto. Das Startguthaben erfolgt mit nächstmöglicher Abrechnung, nachdem der Umsatz erstmalig erreicht wurde. Anspruch auf das Startguthaben haben nur Antragsteller, die innerhalb der letzten 18 Monate nicht als Hauptkarteninhaber einer deutschen American Express Platinum Card registriert waren. Das Startguthaben kann nicht ausgezahlt werden, sondern kann nur mit weiteren Kartenbelastungen verrechnet werden. Im Falle einer Kartenkündigung innerhalb der ersten 12 Monate erlischt der Anspruch auf das Startguthaben.
        </p>

        <p>
          3) Weitere Informationen, Bedingungen und Einschränkungen finden Sie{' '}
          <a
            href="https://www.americanexpress.com/de/vorteile/the-platinum-card/online-reiseguthaben.html"
            target="_blank"
            rel="noopener noreferrer">
            hier
          </a>
          .
        </p>

        <p>
          4) Alle Details zu den Leistungen und Versicherungen finden Sie{' '}
          <a
            href="https://www.americanexpress.com/content/dam/amex/de/benefits/bedingungen/Platinum_Card_Informationen.pdf"
            target="_blank"
            rel="noopener noreferrer">
            hier
          </a>
          .
        </p>

        <p>
          5) Der Gegenwert der Zusatzkarten wird nicht ausgezahlt bzw. nicht dem Kartenkonto gutgeschrieben, falls die Zusatzkarte nicht in Anspruch genommen wird.
        </p>

  	  <p>
          6) Mehr Informationen, Bedingungen und Anmeldung mit den Zugangsdaten Ihres Online-Kartenkontos finden Sie{' '}
  		<a
            href="http://www.americanexpress.de/business-platinum-fahrtguthaben"
            target="_blank"
            rel="noopener noreferrer">
            hier
          </a>
          .
        </p>

          <p>
              7) Es gelten{' '}
              <a
                href="https://www.americanexpress.com/de/vorteile/shop-small/"
                target="_blank"
                rel="noopener noreferrer">
                Bedingungen
              </a>.
          </p>

          <p>
              8) Der Membership Rewards Wert basiert auf dem durchschnittlichen Jahresumsatz von Karteninhabern, einer Sammelrate von 1 Euro = 1 Punkt. Die Wertigkeit der Punkte basiert auf den möglichen Einlöse-Optionen im Programm wie Zahlen mit Punkten inkl. der Option für die Jahresgebühr sowie Euro-Wertgutscheinen. Der Punktewert kann sich je nach Einlöse-Option jederzeit ändern und ist aktuell zum Zeitpunkt der Einlösung einsehbar.
          </p>

        <p>
          Alle detaillierten Informationen zu Schutz und Sicherheit finden Sie{' '}
          <a
            href="https://www.americanexpress.com/de/content/security/?inav=de_sitefooter_importantlinks_security"
            target="_blank"
            rel="noopener noreferrer">
            hier
          </a>
          .
        </p>
      </Footer>

      <div
        style={{ width: 0, height: 0, overflow: 'hidden' }}
        dangerouslySetInnerHTML={{ __html: tracking }}
      />
      <Optimize />
    </Layout>
  )
}

export default PlatinumPage

export const query = graphql`
  query {
    storyImage_01_Platinum: file(
      relativePath: { eq: "platinum_relaunch/story_01.jpg" }
    ) {
      ...FragmentStoryImage
    }
    storyImage_01_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/story_01_mobile.jpg" }
    ) {
      ...FragmentStoryImageMobile
    }
    storyImage_02_Platinum: file(
      relativePath: { eq: "platinum_relaunch/story_02.jpg" }
    ) {
      ...FragmentStoryImage
    }
    storyImage_02_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/story_02_mobile.jpg" }
    ) {
      ...FragmentStoryImageMobile
    }
    storyImage_03_Platinum: file(
      relativePath: { eq: "platinum_relaunch/story_03.jpg" }
    ) {
      ...FragmentStoryImage
    }
    storyImage_03_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/story_03_mobile.jpg" }
    ) {
      ...FragmentStoryImageMobile
    }
    contentImage_01_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_01_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_01_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_01_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_01a_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_01a_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_01a_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_01a_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_02_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_02_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_02_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_02_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_03_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_03_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_03_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_03_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_04_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_04_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_04_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_04_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_05_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_05_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_05_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_05_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_06_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_06_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_06_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_06_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_07_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_07_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_07_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_07_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_08_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_08_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_08_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_08_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_09_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_09_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_09_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_09_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_10_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_10_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_10_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_10_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_11_Platinum: file(
      relativePath: { eq: "platinum_relaunch/content_11_platinum.jpg" }
    ) {
      ...FragmentContentImage
    }
    contentImage_11_Platinum_mobile: file(
      relativePath: { eq: "platinum_relaunch/content_11_platinum_mobile.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_01_Platinum_col: file(
      relativePath: { eq: "platinum_relaunch/content_01_platinum_col.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_03_Platinum_col: file(
      relativePath: { eq: "platinum_relaunch/content_03_platinum_col.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_04_Platinum_col: file(
      relativePath: { eq: "platinum_relaunch/content_04_platinum_col.jpg" }
    ) {
      ...FragmentContentImageMobile
    }
    contentImage_06_Platinum_col: file(
      relativePath: { eq: "platinum_relaunch/content_06_platinum_col.jpg" }
    ) {
      ...FragmentContentImageMobile
    }


    boxPackaging: file(relativePath: { eq: "platinum_relaunch/box_packaging.png" }) {
      childImageSharp {
        fluid: fluid(maxWidth: 800, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    boxInlay: file(relativePath: { eq: "platinum_relaunch/box_inlay.png" }) {
      childImageSharp {
        fluid: fluid(maxWidth: 800, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    cardImagePlatinum: file(
      relativePath: { eq: "platinum_relaunch/card_platinum.png" }
    ) {
      childImageSharp {
        intro: fixed(width: 206) {
          ...GatsbyImageSharpFixed
        }
        sticky: fixed(width: 111) {
          ...GatsbyImageSharpFixed
        }
        fluid: fluid(maxWidth: 400, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    cardImagePlatinumBusiness: file(
      relativePath: { eq: "platinum_relaunch/card_platinum_business.png" }
    ) {
      childImageSharp {
        fluid: fluid(maxWidth: 400, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    cardImagePlatinumPerspective: file(
      relativePath: { eq: "platinum_relaunch/card_platinum_perspective.png" }
    ) {
      childImageSharp {
        fluid: fluid(maxWidth: 600, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const tracking = `
<script src="http://www.americanexpress.com/adobetrackingconsent"></script>

<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WSV8C65"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->

<!-- Universal Tracking Tag Amex Platinum -->
<script type="text/javascript" charset="utf-8">
	var utm268 = {};
	utm268.data = {
		/* Settings General */
		advertiser_id: 'adv_m10030_1_294', // do not change
		pt_pagetype: 'product', // insert pagetype, possible values: 'home', 'product', 'category', 'conversion'
		pt_checkout: '', // insert orderstep 1-n (optional)
		/* Conversion */
		pt_conversion: '', // specify your conversion type, e.g. 'lead' or 'order' (optional)
		pt_conversion_orderid: '', // insert your order ID or unique identifer (mandatory)
		pt_conversion_total: '', // insert value of basket (optional)
		pt_conversion_quantity: '', // insert number of purchased products (optional)
		pt_conversion_success: '', // if Lasttouch / deduplication (Cookie-Weiche) insert 1, for hardcoded 0; Default 0
		/* Settings Categories */
		pt_category: '', // insert main category
		pt_subcategory1: '', // insert subcategory 1
		pt_subcategory2: '', // insert subcategory 2
		pt_subcategory3: '', // insert subcategory 3
		/* Settings Product */
		pt_productname: 'platinum', // insert product name
		pt_productid: '', // insert product id
		/* Settings Custom Variables */
		pt_customvar1: '', // insert value for defined customvar1
		pt_customvar2: '', // insert value for defined customvar2
		pt_customvar3: '', // insert value for defined customvar3
		pt_customvar4: '', // insert value for defined customvar4
		pt_customvar5: '', // insert value for defined customvar5
		/* Do not change */
		pt_loc: decodeURI(document.location.href), // do not change
		pt_ref: decodeURI(document.referrer), // do not change
		pt_protocol: (("https:" == document.location.protocol) ? "https://" : "http://"), // do not change
		pt_cachebuster: new Date().getTime() // do not change
	};
	(function(w,d,s,f,v) {
		w[v] = w[v] || [];
		var e = d.getElementsByTagName(s)[0],
			j = d.createElement(s);
		j.async = true;
		j.src = f;
		e.parentNode.insertBefore(j, e);
	})(window, document,"script","https://utt.pm/utm/268/adv_m10030_1_294.js","utm268");
</script>

<!-- End Universal Tracking Tag Amex Platinum -->

<!-- Begin Exactag -->
<script type="text/javascript">
var exactag = {};
exactag.campaign = "d2cb3973d7b30517a986f08ed7459ae7";
exactag.sitegroup = "landingpage";
</script>
<script type="text/javascript" src="https://cdn.exactag.com/js/exactag.js"></script>
<!-- End Exactag -->

<!-- Facebook Pixel Code -->
<script>
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '562383967540068');
fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1" style="display:none"
src="//www.facebook.com/tr?id=562383967540068&amp;ev=PageView&noscript=1"
/></noscript>
<!-- DO NOT MODIFY -->
<!-- End Facebook Pixel Code -->

<!-- Google Code for Remarketing Tag -->
<!--------------------------------------------------
Remarketing tags may not be associated with personally identifiable information or placed on pages related to sensitive categories. See more information and instructions on how to setup the tag on: http://google.com/ads/remarketingsetup
--------------------------------------------------->
<script type="text/javascript">
/* <![CDATA[ */
var google_conversion_id = 975872748;
var google_custom_params = window.google_tag_params;
var google_remarketing_only = true;
/* ]]> */
</script>
<script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js">
</script>
<noscript>
<div style="display:inline;">
<img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/975872748/?guid=ON&amp;script=0"/>
</div>
</noscript>

<script type='text/javascript'>
// Conversion Name: American-Express_Landingpage_Retargeting_PlatinumCard
var ebRand = Math.random()+'';
ebRand = ebRand * 1000000;
//<![CDATA[
document.write('<scr'+'ipt src="HTTPS://bs.serving-sys.com/Serving/ActivityServer.bs?cn=as&amp;ActivityID=1218614&amp;rnd=' + ebRand + '"></scr' + 'ipt>');
//]]>
</script>
<noscript>
<img width="1" height="1" style="border:0" src="HTTPS://bs.serving-sys.com/Serving/ActivityServer.bs?cn=as&amp;ActivityID=1218614&amp;ns=1"/>
</noscript>
<!-- Global site tag (gtag.js) - Google AdWords: 877585581 -->
<script async src="https://www.googletagmanager.com/gtag/js?id=AW-877585581"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'AW-877585581');
</script>
<!-- End Google Code for Remarketing Tag -->

<!-- Event snippet for Platinum Card beantragt conversion page -->
<script>
gtag('event', 'conversion', {'send_to': 'AW-877585581/lE74CNjwsoMBEK3Ju6ID'});
</script>
<!-- Event snippet for Platinum Card beantragt conversion page -->

<!-- Start Container-Pixel von LightReaction -->
<iframe allowtransparency="true" scrolling="no" frameborder="0" border="0" width="1" height="1" marginwidth="0" marginheight="0" background-color="transparent" src="https://ad2.adfarm1.adition.com/track?tid=14183&sid=39449&type=html&orderid=&itemno=&descr=&quantity=&price=0.00&total=0.00"></iframe>
<!-- End Container-Pixel von LightReaction -->

<!-- Start Pixel EDA Programmatic Unit UM AMEX London -->
<img height="1" width="1" style="border-style:none;" alt="" src="//insight.adsrvr.org/track/conv/?adv=5t0y1jn&ct=0:qysr5p5&fmt=3"/>
<!-- End EDA Programmatic Unit UM AMEX London -->

<!--
Start of DoubleClick Floodlight Tag: Please do not remove
Activity name of this tag: FAST – Germany Platinum Card Product Page – D2
URL of the webpage where the tag is expected to be placed: https://www.amex-kreditkarten.de/angebot-platinum/
This tag must be placed between the opening and closing body tags, as close as possible to the opening tag.
Creation Date: 06/15/2018
-->
<script type="text/javascript">
var axel = Math.random() + "";
var a = axel * 10000000000000;
document.write('<img src="https://ad.doubleclick.net/ddm/activity/src=3852110;type=ldp;cat=fastg000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a + '?" width="1" height="1" alt=""/>');
</script>
<noscript>
<img src="https://ad.doubleclick.net/ddm/activity/src=3852110;type=ldp;cat=fastg000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" alt=""/>
</noscript>
<!-- End of DoubleClick Floodlight Tag: Please do not remove -->

<!-- Segment Pixel 15979828 - DO NOT MODIFY --><script src="https://secure.adnxs.com/seg?add=15979828&t=1" type="text/javascript"></script><!-- End of Segment Pixel -->

<!-- Use of this pixel is subject to the Amazon ad specs and policies at http://www.amazon.com/b/?&node=7253015011 --><img height='1' width='1' border='0' alt='' src='https://aax-eu.amazon-adsystem.com/s/iui3?d=forester-did&ex-fargs=%3Fid%3D1942aacb-5304-0b64-579b-d49c64b3f384%26type%3D7%26m%3D4&ex-fch=416613&ex-src=https://www.americanexpress.com/de/kreditkarte/platinum-card/&ex-hargs=v%3D1.0%3Bc%3D5765058860102%3Bp%3D1942AACB-5304-0B64-579B-D49C64B3F384' />
<img height='1' width='1' border='0' alt='' src='https://aax-eu.amazon-adsystem.com/s/iui3?d=forester-did&ex-fargs=%3Fid%3D600b21ac-b15a-6fa3-1133-0afffd3f8ada%26type%3D12%26m%3D4&ex-fch=416613&ex-src=https://www.amazon.de&ex-hargs=v%3D1.0%3Bc%3D1329789425789%3Bp%3D600B21AC-B15A-6FA3-1133-0AFFFD3F8ADA' />


<!-- BEGIN: LinkedIn -->
<script type="text/javascript">
_linkedin_partner_id = "2611937";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);
</script><script type="text/javascript">
(function(){var s = document.getElementsByTagName("script")[0];
var b = document.createElement("script");
b.type = "text/javascript";b.async = true;
b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})();
</script>
<noscript>
<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2611937&fmt=gif" />
</noscript>
<!-- END: LinkedIn -->
`

const appendCssToHead = `
  .async-hide { opacity: 0 !important }
`

const appendJsToHead = `
/* Ensighten */
window.euLocale = 'DE_de';

/* Page Hiding Snippet */
(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date; h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')}; (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c; })(window,document.documentElement,'async-hide','dataLayer',4000, {'GTM-MX2TSVW':true});

/* Optimize Container Code */
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){ (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) })(window,document,'script','https://www.google-analytics.com/analytics.js','ga'); ga('create', 'UA-139964173-2', 'auto'); ga('require', 'GTM-MX2TSVW');

/* GTM Container Code */
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WSV8C65');

/* Pinterest */
!function(e){if(!window.pintrk){window.pintrk = function () {
window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
n=window.pintrk;n.queue=[],n.version="3.0";var
t=document.createElement("script");t.async=!0,t.src=e;var
r=document.getElementsByTagName("script")[0];
r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
pintrk('load', '2612918883631', {em: '<user_email_address>'});
pintrk('page');
`
